module.exports = __webpack_public_path__ + "static/media/tingxinliuzhishenqingbiao.41e57d78.png";